import React from "react";

// Реквизиты продавца. Публикация обязательна по правилам платёжных систем,
// провайдер эквайринга проверяет их наличие на сайте.
// Адрес и ИИН — по уведомлению о начале деятельности № KZ29UWQ06967954
// от 06.12.2024. Банковские реквизиты на сайте не публикуются.
const COMPANY = {
  legalName: "Индивидуальный предприниматель Конурова Дина Азаматовна",
  bin: "951116450102", // ИИН — у ИП заменяет БИН
  legalAddress: "Республика Казахстан, г. Астана, ул. Толе би, 57, НП6, 010007",
  phone: "+7 747 555 4668",
  email: "info@vanilkz.kz",
};

const PHONES = [
  { label: "Толе би", phone: "77474604853" },
  { label: "ул. Кенесары", phone: "77057244351" },
  { label: "Нурмаганбетова", phone: "77071065985" },
];

const RefundPolicyPage = () => {
  return (
    <main className="container mx-auto px-4 py-8">
      <header className="mb-8">
        <h1 className="text-3xl font-bold">Условия возврата и отмены платежей</h1>
        <p className="mt-3 text-gray-600">
          Порядок отмены заказа, возврата товара и возврата денежных средств в интернет-магазине «Vanil».
        </p>
      </header>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">1. Общие положения</h2>
        <p className="mb-4">
          Настоящие условия описывают порядок отмены заказа, возврата товара и возврата денежных средств покупателю
          при покупке в интернет-магазине «Vanil». Условия применяются ко всем заказам, оформленным на сайте,
          независимо от выбранного способа оплаты.
        </p>
        <p className="mb-4">
          Возврат производится в соответствии с законодательством Республики Казахстан, в том числе с Законом
          Республики Казахстан «О защите прав потребителей».
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">2. Отмена заказа до отправки</h2>
        <p className="mb-4">
          Покупатель вправе отказаться от заказа в любой момент до его передачи в доставку. Для этого достаточно
          связаться с магазином по телефону или в WhatsApp, указав номер заказа.
        </p>
        <p className="mb-4">
          Если заказ был оплачен, денежные средства возвращаются в полном объёме, включая стоимость доставки.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">3. Возврат товара ненадлежащего качества</h2>
        <p className="mb-4">
          Если товар получен с браком, повреждением, нарушенной упаковкой, истёкшим сроком годности либо не
          соответствует описанию на сайте, покупатель вправе обратиться в магазин в течение 14 календарных дней
          с момента получения заказа.
        </p>
        <p className="mb-4">
          По результатам обращения покупателю по его выбору предоставляется замена товара, соразмерное уменьшение
          цены либо возврат уплаченной суммы. Расходы на обратную доставку такого товара несёт магазин.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">4. Возврат товара надлежащего качества</h2>
        <p className="mb-4">
          Парфюмерно-косметические товары входят в перечень непродовольственных товаров надлежащего качества,
          не подлежащих обмену и возврату в соответствии с законодательством Республики Казахстан. Товар,
          упаковка которого вскрыта, а также товар, бывший в употреблении, возврату не подлежит.
        </p>
        <p className="mb-4">
          Если товар не вскрывался и полностью сохранил товарный вид, упаковку, пломбы и заводскую маркировку,
          магазин рассматривает обращение индивидуально. Обратиться необходимо в течение 14 календарных дней
          с момента получения заказа. Расходы на обратную доставку в этом случае несёт покупатель.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">5. Как оформить возврат</h2>
        <ol className="list-decimal pl-6 mb-4 space-y-2">
          <li>Свяжитесь с магазином по телефону, в WhatsApp или по электронной почте и сообщите номер заказа, наименование товара и причину возврата.</li>
          <li>При возврате товара ненадлежащего качества приложите фотографии товара и упаковки — это ускорит рассмотрение.</li>
          <li>Магазин рассматривает обращение в течение 3 рабочих дней и согласовывает с вами способ передачи товара.</li>
          <li>После получения и проверки товара магазин инициирует возврат денежных средств.</li>
        </ol>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">6. Сроки и способ возврата денежных средств</h2>
        <p className="mb-4">
          Денежные средства возвращаются тем же способом, которым была произведена оплата. При оплате банковской
          картой возврат производится <strong>только на ту карту, с которой была совершена оплата</strong>; возврат
          наличными или на другую карту в этом случае невозможен.
        </p>
        <p className="mb-4">
          Магазин инициирует возврат в течение 3 рабочих дней с момента согласования возврата либо получения
          возвращаемого товара. Срок зачисления денег на счёт зависит от банка, выпустившего карту, и составляет
          до 30 календарных дней с момента инициирования возврата, как правило — значительно быстрее.
        </p>
        <p className="mb-4">
          Возврат может быть выполнен как полностью, так и частично — например, если возвращается только часть
          товаров из заказа.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">7. Если возникли проблемы с оплатой</h2>
        <p className="mb-4">
          Если платёж не прошёл, оплата была отклонена банком или деньги списались, а заказ не отобразился —
          не проводите оплату повторно. Свяжитесь с магазином и сообщите номер заказа, дату, время и сумму платежа.
        </p>
        <p className="mb-4">
          Отклонённый платёж не приводит к списанию средств. Если сумма была временно заблокирована банком,
          она возвращается автоматически. При двойном списании магазин возвращает лишнюю сумму на карту
          в порядке, описанном в разделе 6.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">8. Безопасность платежей</h2>
        <p className="mb-4">
          Оплата банковской картой производится на защищённой платёжной странице банка-эквайера. Данные карты
          передаются в зашифрованном виде напрямую в банк, не попадают в интернет-магазин и не хранятся на его
          серверах. Операции проходят с использованием технологии 3-D Secure — подтверждения платежа кодом от
          банка, выпустившего карту.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">9. Контакты для обращений</h2>
        {COMPANY.legalName && <p className="mb-2"><strong>Продавец:</strong> {COMPANY.legalName}</p>}
        {COMPANY.bin && <p className="mb-2"><strong>ИИН:</strong> {COMPANY.bin}</p>}
        {COMPANY.legalAddress && <p className="mb-2"><strong>Адрес:</strong> {COMPANY.legalAddress}</p>}
        {COMPANY.phone && (
          <p className="mb-2">
            <strong>Телефон:</strong>{" "}
            <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="text-pink-500 hover:underline">
              {COMPANY.phone}
            </a>
          </p>
        )}
        {COMPANY.email && (
          <p className="mb-2">
            <strong>Электронная почта:</strong>{" "}
            <a href={`mailto:${COMPANY.email}`} className="text-pink-500 hover:underline">
              {COMPANY.email}
            </a>
          </p>
        )}
        <p className="mb-2"><strong>Телефоны магазинов:</strong></p>
        <ul className="list-disc pl-6 mb-4">
          {PHONES.map(({ label, phone }) => (
            <li key={phone}>
              {label}:{" "}
              <a
                href={`https://wa.me/${phone}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-500 hover:underline"
              >
                +{phone}
              </a>
            </li>
          ))}
        </ul>
        <p className="mb-4">
          Магазины работают ежедневно с 10:00 до 22:00. Обращения по возвратам рассматриваются в рабочее время.
        </p>
      </section>
    </main>
  );
};

export default RefundPolicyPage;
